import React from 'react';
import { Note } from '@/store/notesStore';
import EncryptedContentPreview from './types/EncryptedContentPreview';
import TextContentPreview from './types/TextContentPreview';
import MDXContentPreview from './types/MDXContentPreview';

interface PreviewNoteContentProps {
  note: Note;
  searchQuery?: string;
}

const PreviewNoteContent: React.FC<PreviewNoteContentProps> = ({ note, searchQuery }) => {
  // Show encrypted preview if note is encrypted
  if (note.encrypted && (note.body_locked || note.content.startsWith('memoslate-body:v1:'))) {
    return <EncryptedContentPreview />;
  }

  // Determine content type and render appropriate preview
  const contentType = note.content_type || 'TEXT';

  switch (contentType) {
    case 'TXT':
      return <TextContentPreview content={note.content} maxLines={20} searchQuery={searchQuery} />;

    case 'MDX':
      return <MDXContentPreview content={note.content} searchQuery={searchQuery} />;

    default:
      return <TextContentPreview content={note.content} searchQuery={searchQuery} />;
  }
};

export default PreviewNoteContent;
